import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as confetti from 'canvas-confetti';

@Component({
  selector: 'app-confetti',
  templateUrl: './confetti.component.html',
  styleUrl: './confetti.component.scss'
})
export class ConfettiComponent implements OnInit {
  @ViewChild('confettiCanvas', { static: true }) confettiCanvas!: ElementRef<HTMLCanvasElement>;

  ngOnInit(): void {
    const canvas = this.confettiCanvas.nativeElement;
    confetti.create(canvas, { resize: true })({
      particleCount: 150,
      spread: 100
    });
  }
}
